// Temporary front fake data for the "Consentements Linky" table, mocking the
// future backend endpoint. Replace once the API is wired.

import { LinkyConsent } from "./linkyConsentsAPI";

export const fakeLinkyConsents: LinkyConsent[] = [
  {
    uuid: "c1000000-0000-4000-8000-000000000001",
    driverName: "Aude Bousquet",
    vehicleEnergyType: "electric",
    consentStatus: "VALIDATED",
    connectionDate: "2026-01-12",
    consentLinkUrl: null,
  },
  {
    uuid: "c1000000-0000-4000-8000-000000000002",
    driverName: "Pierre Dupont",
    vehicleEnergyType: "hybrideFuel",
    consentStatus: "VALIDATED",
    connectionDate: "2026-01-12",
    consentLinkUrl: null,
  },
  {
    uuid: "c1000000-0000-4000-8000-000000000003",
    driverName: "Lauriane Sabard",
    vehicleEnergyType: "hybrideDiesel",
    consentStatus: "PENDING",
    connectionDate: null,
    consentLinkUrl: "https://consent.qivia.fr/linky/c1000000-3",
  },
  {
    uuid: "c1000000-0000-4000-8000-000000000004",
    driverName: "Mathieu Thompson",
    vehicleEnergyType: "fuel",
    consentStatus: "PENDING",
    connectionDate: null,
    consentLinkUrl: "https://consent.qivia.fr/linky/c1000000-4",
  },
  {
    uuid: "c1000000-0000-4000-8000-000000000005",
    driverName: "Sophie Marchand",
    vehicleEnergyType: "diesel",
    consentStatus: "PENDING",
    connectionDate: null,
    consentLinkUrl: "https://consent.qivia.fr/linky/c1000000-5",
  },
  {
    uuid: "c1000000-0000-4000-8000-000000000006",
    driverName: "Karim Benali",
    vehicleEnergyType: "GPL",
    consentStatus: "VALIDATED",
    connectionDate: "2026-01-08",
    consentLinkUrl: null,
  },
  {
    uuid: "c1000000-0000-4000-8000-000000000007",
    driverName: "Elena Rossi",
    vehicleEnergyType: "GNV",
    consentStatus: "PENDING",
    connectionDate: null,
    consentLinkUrl: "https://consent.qivia.fr/linky/c1000000-7",
  },
];
